// Official Government of Nepal public holidays (nationwide only).
// Source: Nepal Gazette Vol. 75, Falgun 18, 2082 BS — Ministry of Home Affairs.
// Keyed by BS year -> "month-day", where month is 1=Baishakh ... 12=Chaitra.
// NOTE: Nepali holidays change every year. When the new Gazette list is
// published (around Falgun/Feb), add that year's block below. Do not compute.

export const NEPAL_HOLIDAYS = {
  2083: {
    "1-1": "New Year",
    "1-18": "Buddha Jayanti",
    "2-15": "Republic Day",
    "5-12": "Janai Purnima",
    "5-19": "Krishna Janmashtami",
    "6-3": "Constitution Day",
    "6-25": "Ghatasthapana",
    "6-31": "Dashain",
    "7-1": "Dashain",
    "7-2": "Dashain",
    "7-3": "Dashain (Bijaya Dashami)",
    "7-4": "Dashain",
    "7-5": "Dashain",
    "7-6": "Dashain",
    "7-22": "Tihar (Laxmi Puja)",
    "7-23": "Tihar",
    "7-24": "Tihar",
    "7-25": "Tihar (Bhai Tika)",
    "7-26": "Tihar",
    "7-29": "Chhath",
    "9-9": "Yomari Punhi",
    "9-10": "Christmas",
    "9-15": "Tamu Lhosar",
    "9-27": "Prithvi Jayanti",
    "10-1": "Maghe Sankranti",
    "10-16": "Martyrs' Day",
    "10-24": "Sonam Lhosar",
    "11-7": "Democracy Day",
    "11-22": "Maha Shivaratri",
    "11-24": "Women's Day",
    "11-25": "Gyalpo Lhosar",
    "12-7": "Holi",
    "12-8": "Holi (Terai)",
  },
};

export function getNepalHoliday(bsYear, bsMonth, bsDay) {
  const year = NEPAL_HOLIDAYS[bsYear];
  if (!year) return null;
  return year[`${bsMonth}-${bsDay}`] || null;
}
